import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../pages/basic/Home';

import Login from '../pages/basic/Login';
import Error401 from '../pages/errorPages/Error401';
import Error403 from '../pages/errorPages/Error403';
import Error404 from '../pages/errorPages/Error404';
import Error500 from '../pages/errorPages/Error500';
import Error401M from '../pages/errorPages/Error401M';
import Error403M from '../pages/errorPages/Error403M';
import Error404M from '../pages/errorPages/Error404M';
import Error500M from '../pages/errorPages/Error500M';

import MobileHome from '../pages/mobile/MobileHome';
import Logout from '../pages/basic/Logout';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="Login" element={<Login />}></Route>
      <Route path="home/*" element={<Home />}></Route>
      <Route path="m/*" element={<MobileHome />}></Route>
      <Route path="logout" element={<Logout />}></Route>
      <Route path="error404" element={<Error404 />}></Route>
      <Route path="error403" element={<Error403 />}></Route>
      <Route path="error401" element={<Error401 />}></Route>
      <Route path="error500" element={<Error500 />}></Route>
      <Route path="error404M" element={<Error404M />}></Route>
      <Route path="error403M" element={<Error403M />}></Route>
      <Route path="error401M" element={<Error401M />}></Route>
      <Route path="error500M" element={<Error500M />}></Route>
      <Route path="*" element={<Home />}></Route>
    </Routes>
  );
};

export default AppRouter;
